export default "__VITE_ASSET__3e798db7__"